import type { ResolvedListings } from "../utils/resolveMatchListings";

export type RowState = "hidden" | "no-default" | "populated";

export function decideRowState(resolved: ResolvedListings): RowState {
    const totalListings = Object.values(resolved.byCountry).reduce((acc, arr) => acc + arr.length, 0);
    if (totalListings === 0) return "hidden";
    if (resolved.defaultCountryListings.length === 0) return "no-default";
    return "populated";
}
